<ng-container *ngIf="readonly">
    <div
    *ngIf="type !== 'checkbox'"
    class="input-container disabled">
        <label>{{label}}</label>
        <div class="display-disabled">{{ disabledTextValue ? disabledTextValue : value}}</div>
        <input
            type="hidden"
            readonly
            disabled
            (focus)="$event.preventDefault()"
            (click)="$event.preventDefault()"
            (change)="$event.preventDefault()"
            (keyDown)="$event.preventDefault()"
            (keyUp)="$event.preventDefault()"
            (keyPress)="$event.preventDefault()"
            [(ngModel)]="value">
    </div>
    <div
    *ngIf="type === 'checkbox'"
    class="input-container checkbox disabled"
    [class.no-margins]="noMargins"
    [class.terms]="terms">
        <label (click)="$event.preventDefault()">
            <input
            type="checkbox"
            (change)="$event.preventDefault()"
            [(ngValue)]="value" [checked]="value">
            <span></span>
            {{label}}
        </label>
    </div>
</ng-container>

<ng-container *ngIf="!readonly" [ngSwitch]="type">

    <ng-container *ngSwitchCase="'select'">
        <div
        class="input-container"
        [class.no-margins]="noMargins"
        [class.error]="(ngControl.control.touched || ngControl.control.dirty) && ngControl.control.invalid">
            <label>{{label}}<span class="red" *ngIf="required" [hidden]="requiredUsuario"> *</span></label>
            <select
            #element
            [(ngModel)]="value"
            (change)="handleChange($event)"
            [class.disabledSelect]="disabledSelect"
            (blur)="onTouchedCallback()">
                <option [value]="" disabled selected>Seleccione...</option>
                <option
                *ngFor="let o of options"
                [value]="optionsKey ? o[optionsKey] : o">
                {{optionsName ? o[optionsName] : o}}</option>
            </select>
        </div>
    </ng-container>

    <ng-container *ngSwitchCase="'selectOnboarding'">
        <div
        class="input-container"
        [class.no-margins]="noMargins"
        [class.error]="(ngControl.control.touched || ngControl.control.dirty) && ngControl.control.invalid">
            <label>{{label}}<span class="red" *ngIf="required"> *</span></label>
            <select style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);"
            #element
            [(ngModel)]="value"
            (change)="handleChange($event)"
            (blur)="onTouchedCallback()">
                <option [value]="" disabled selected>Seleccione...</option>
                <option
                *ngFor="let o of options"
                [value]="optionsKey ? o[optionsKey] : o">
                {{optionsName ? o[optionsName] : o}}</option>
            </select>
        </div>
    </ng-container>

    <ng-container *ngSwitchCase="'selectOnboardingSize'">
        <div
        class="input-container"
        [class.no-margins]="noMargins"
        [class.error]="(ngControl.control.touched || ngControl.control.dirty) && ngControl.control.invalid">
            <label>{{label}}<span class="red" *ngIf="required"> *</span></label>
            <select style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);"
            #element
            size="2"
            [(ngModel)]="value"
            (change)="handleChange($event)"
            (blur)="onTouchedCallback()">
                <option [value]="" disabled selected>Seleccione...</option>
                <option
                *ngFor="let o of options"
                [value]="optionsKey ? o[optionsKey] : o">
                {{optionsName ? o[optionsName] : o}}</option>
            </select>
        </div>
    </ng-container>

    <div
    *ngSwitchCase="'checkbox'"
    class="input-container checkbox"
    [class.no-margins]="noMargins"
    [class.terms]="terms"
    [class.error]="(ngControl.control.touched || ngControl.control.dirty) && ngControl.control.invalid">
        <label>
            <input type="checkbox" (change)="handleChange($event)" [(ngValue)]="value" [checked]="value">
            <span></span>
            {{label}}
        </label>
    </div>

    <div
    *ngSwitchCase="'textarea'"
    class="input-container"
    [class.no-margins]="noMargins"
    [class.error]="(ngControl.control.touched || ngControl.control.dirty) && ngControl.control.invalid">
        <label>{{label}}<span class="red" *ngIf="required"> *</span></label>
        <textarea
        #element
        [(ngModel)]="value"
        (keyup)="handleChange($event)"
        (blur)="onTouchedCallback()"></textarea>
    </div>

    <div
    *ngSwitchCase="'file'"
    class="input-container file"
    [class.error]="((ngControl.control.touched || ngControl.control.dirty) && ngControl.control.invalid) || formatError">
        <input
        #element
        *ngIf="file==null"
        type="file"
        (change)="handleFileChange($event)"
        [accept]="accept">

        <div class="content-img">
            <div class="dropzone" [class.preview]="file!=null" (click)="fileInputClick()" (drop)="drop($event)" (dragover)="allowDrop($event)">
                <div class="d-flex content-file">
                    <img *ngIf="file!=null" class="img-file" src='../../assets/img/noe-free/icon-nombre-documento.png' style="width: 40px; height: 50px; display: block; margin: 0 auto; margin-right: 30px;">
                    <span *ngIf="!editNameCertificado" class="text-file">{{file?.name}}</span>
                    <span contenteditable id="nameModificado" *ngIf="editNameCertificado && file!=null" style="font-size: 20px;color: #1a6994;font-weight: bold;padding: .5em .5em;border: 1px solid #1a6994;border-radius: 2px;">{{nameCertificado}} </span>
                </div>
                <div class="d-flex content-file" *ngIf="file!=null">
                    <div class="tooltipModal" (click)="editName()">
                        <div class="remove"><img src='../../assets/img/noe-free/icon-nombre-certificado.png' class="img-file" style="height: 45px; display: block; margin: 0 auto; margin-right: 30px;"></div>
                        <div class="tooltiptextModal">
                            <span>DALE NOMBRE A TU CERTIFICADO</span>
                        </div>
                    </div>
                    <div class="remove" (click)="editNameCertificado=false;file=null;"><img src='../../assets/img/noe-free/icon-eliminar.png' style="height: 45px; display: block; margin: 0 auto;"></div>
                </div>
                <div *ngIf="file==null" class="file-input-display">
                    <img src='../../assets/img/noe-free/icon-cargar-documentos.png' style="width: 50px; display: block; margin: 0 auto; margin-bottom: 10px;">
                    <span class="title-img">Arrastra o carga tus certificados</span><br>
                    <span class="title-formato">Formatos soportados: .p12 o .pfx</span><br>
                </div>
            </div>
            <div *ngIf="file==null" class="footer-btn">
                <button class="btn-cargar" type="submit" (click)="fileInputClick()">Cargar</button>
            </div>
            <div *ngIf="file!=null" class="botones-date d-flex">
                <button class="btn-continuar" (click)="abrilModalPinSession()">Continuar</button>
            </div>
        </div>

    </div>

    <div
    *ngSwitchDefault
    class="input-container"
    [class.no-margins]="noMargins"
    [class.disabled]="readonly || disabled"
    [class.error]="((ngControl.control.touched || ngControl.control.dirty) && ngControl.control.invalid) || correoError || existeDoc">
        <label>{{label}}<span class="red" *ngIf="required" [hidden]="requiredUsuario"> *</span></label>
        <input
            #element
            [autocomplete]="autocomplete"
            [placeholder]="placeholder"
            [type]="type"
            [(ngModel)]="value"
            (keyup)="handleChange($event)"
            (blur)="onTouchedCallback()"
            (input)="onInput($event)"
            [step]="step"
            [readonly]="readonly"
            [disabled]="disabled"
            onKeyPress="if(value.length==20 && type === 'number') return false"
            [maxlength]="vMax">
    </div>
</ng-container>

<div class="error-block" *ngIf="((ngControl.control.touched || ngControl.control.dirty) && ngControl.control.invalid) || formatError || correoError">
    <p *ngIf="ngControl.control.errors?.required">Este campo es obligatorio</p>
    <p *ngIf="ngControl.control.errors?.email || (!ngControl.control.errors?.required && correoError)">Correo electrónico inválido</p>
    <p *ngIf="ngControl.control.errors?.min">El valor está por debajo del requerido</p>
    <p *ngIf="ngControl.control.errors?.mismatch">Las contraseñas deben coincidir</p>
    <p *ngIf="ngControl.control.errors?.minlength">El valor debe tener un mínimo de {{ngControl.control.errors?.minlength.requiredLength}} caracteres</p>
    <p *ngIf="ngControl.control.errors?.maxlength">El valor no debe exceder los {{ngControl.control.errors?.maxlength.requiredLength}} caracteres</p>
    <p *ngIf="ngControl.control.errors?.pattern && !number">El valor no puede contener ningun de los siguientes caracteres: / \ : * " > < | </p>
    <p *ngIf="ngControl.control.errors?.pattern && number">Solo se permiten caracteres numéricos.</p>
</div>

<div class="error-block fondo-cert" *ngIf="formatError">
   <p *ngIf="formatError">Formato de archivo inválido</p>
</div>
